import { useEffect, useState } from "react";

const useCurrentTime = () => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const d = new Date();
      const formattedTime = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
      setTime(formattedTime);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return time;
};

export { useCurrentTime };
